import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  HttpErrorHandlerService,
  HandleError,
} from '../config/http-error-handler.service';
import { BaseSvcService } from '../config/base-svc.service';
import { AppOfflineStore } from '../../app.offlineService';
import { SessionService } from '../session.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class QuestionManagementService {
  private handleError: HandleError;
  public url: string;
  public options;
  public Currentlatexcontent: any;
  public QuestionByIDlist: any;
  public QuestionBodylist: any;
  public AnswerChoicelist: any;
  public AnswerChoiceNotelist: any;
  public Previewlist: any;
  public SelectSubject: string;
  public ScreenTrackName: string;

  public loginlist = {
    LoggedInUserID: this.session.getUser(),
    sessionLanguageTypeCode: this.appserv.userlanuage,
  };
  constructor(
    private http: HttpClient,
    public session: SessionService,
    private appserv: AppOfflineStore,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }

  GetCode(data: { Tablename: string } | string): Observable<any[]> {
    const tableName = typeof data === 'string' ? data : data?.Tablename;
    const url = `${this.url}api/GetCodes/${tableName}`;
    return this.http.get<{ resultList: any[] }>(url, this.options).pipe(
      map((response) => response.resultList),
      catchError(this.handleError<any[]>('getQuestion', []))
    );
  }

  getCodes(data: any): Observable<any[]> {
    if (typeof data === 'string') {
      return this.http
        .get<{ resultList: any[] }>(`${this.url}api/GetCodes/${data}`, this.options)
        .pipe(
          map((response) => response.resultList),
          catchError(this.handleError<any[]>('getCodes', []))
        );
    }
    return this.http.get<any[]>(`${this.url}api/getCodes`, {
      params: data,
    });
  }

  GetPowerUserList(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post(this.url + 'api/GetPowerUserList', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getSubjectTree(data: any): Observable<any[]> {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;

    return this.http
      .post<any>(this.url + 'api/GetSubjectTreeNodes', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getsubjectById(data: any) {
    let request: any = {
      CurrentNodeSubjectID: Number(data.CurrentNodeSubjectID),
      LoggedInUserID: this.session.getUser(),
      sessionLanguageTypeCode: this.appserv.userlanuage,
    };
    return this.http
      .post<any>(this.url + 'api/GetSubjectByID', request, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionList(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetQuestionList', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  GetQuestionSubject(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetQuestionSubject', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionTemplate(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetQuestionTemplate', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionByID(data: any) {
    //data.push(this.loginlist);
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetQuestionByID', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  getBreadcrumbDetails(data: any) {
    return this.http
      .get<any[]>(
        this.url + 'api/GetSubjectNodePathByID/' + data.ID,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }


  CreateOrModifyQuestion(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/InsertOrUpdateQuestion', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  RelocateQuestion(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any>(this.url + 'api/RelocateQuestion', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetAnswerChoiceByQuestionID(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(
        this.url + 'api/GetAnswerChoiceByQuestionID',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetAnserChoiceNoteByID(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetAnswerChoiceNoteByID', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetAnserChoiceByID(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetAnswerChoiceByID', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifyAnswerChoiceNote(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any>(
        this.url + 'api/InsertOrUpdateAnswerChoiceNote',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifyAnswerChoice(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any>(
        this.url + 'api/InsertOrUpdateAnswerChoice',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionStatusByID(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetQuestionStatusByID', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifyQuestionStatus(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any>(
        this.url + 'api/InsertOrUpdateQuestionStatus',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionStatusHistory(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(
        this.url + 'api/GetQuestionStatusChangeHistory',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  DeleteAnswerChoice(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any>(this.url + 'api/DeleteAnswerChoice', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  GetQuestionActivityHistory(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;

    return this.http
      .post<any[]>(
        this.url + 'api/GetQuestionActivityHistory',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetCodeExam(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .get<any[]>(
        this.url + 'api/GetCodesSubject/' + data.Tablename,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionAppearance(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetQuestionPreviousAppearance',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  InsertOrUpdateQuestionAppearance(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any[]>(
        this.url + 'api/InsertOrUpdateQuestionPreviousAppearance',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  GetQuestionUsageSetting(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(this.url + 'api/GetQuestionUsageSetting', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionMonthlyReport(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/ReportGetQuestionMonthlyCount',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetQuestionReportWithStatus(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/ReportGetQuestionWithStatus',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetSearchStringInQuestion(data: any) {
    data.LoggedInUser = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GETSearchStringInQuestion',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetSearchStringInFlashcard(data: any) {
    data.LoggedInUser = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GETSearchStringInFlashcard',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  InsertOrUpdateQuestionUsage(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any[]>(
        this.url + 'api/InsertOrUpdateQuestionUsageSetting',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  getActivityHistorySync(data: any): Promise<any> {
    return this.GetQuestionActivityHistory(data).toPromise();
  }
  getQuestionSync(data: any): Promise<any> {
    return this.GetQuestionByID(data).toPromise();
  }
}
